import { types, actions } from './requests'
export const CREATECATEGORY_TYPES = {
    ...types('CREATECATEGORY'),
}
export const CREATECATEGORY_ACTIONS = {
    ...actions('CREATECATEGORY'),
}
